export default {
    filters: {
    truncate: function(value, length, omission) {
        length = length ? parseInt(length, 10) : 20;
        var ommision = omission ? omission.toString() : '...';

        if (value == undefined) {
            return value;
        }

        if (value.length <= length) {
            return value;
        }

        return value.substring(0, length) + ommision;
    },
  },
}